import { addBusinessDays, todayParis } from '../utils/calendar.mjs';
export function cvFollowUps(rows, clients, closures = [], days = 2) {
  const groups = new Map();
  for (const row of rows) {
    if (row.status !== 'sent' || (row.clientDecision && row.clientDecision !== 'pending')) continue;
    const sent = new Date(row.sentAt || row.createdAt);
    if (Number.isNaN(sent.getTime())) continue;
    const client = clients.find(c => [c.id,c.client_id,c._id].some(value => value != null && String(value) === String(row.clientId)));
    if (!client) continue;
    const entries = groups.get(client.id) || [];
    if (!entries.some(entry => entry._id === row._id)) entries.push(row);
    groups.set(client.id, entries);
  }
  return [...groups].map(([clientId, entries]) => {
    entries.sort((a,b) => Date.parse(b.sentAt || b.createdAt) - Date.parse(a.sentAt || a.createdAt));
    const latest = entries[0];
    const presentations = entries.map(row => ({...row, due:addBusinessDays(todayParis(new Date(row.sentAt || row.createdAt)), days, closures)}));
    const due = presentations.map(row => row.due).sort()[0];
    return { id:`cv-follow-${clientId}`,clientId,automationKey:'cv-follow',category:'follow',title:'Relancer les CV anonymisés envoyés',done:false,due_date_original:due,scheduled_date:due,createdAt:latest.sentAt || latest.createdAt,
      presentations,
      notes:presentations.map(row => `${row.reference || 'CV anonymisé'}${row.candidateName ? ` · ${row.candidateName}` : ''} · ${todayParis(new Date(row.sentAt || row.createdAt))} · Relance le ${row.due.split('-').reverse().join('/')}${row.message ? `\n${row.message}` : ''}`).join('\n\n'),
      presentationIds:entries.map(row => row._id) };
  });
}
